'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    // Sentry ya intercepta, pero esto garantiza el evento
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <h2>Algo salió mal</h2>
        <pre>{error.message}</pre>
        <button onClick={() => reset()}>Reintentar</button>
      </body>
    </html>
  );
}
